/**
 * Browser blob-download helpers for the alg app.
 *
 * Used to export a protocol spec JSON and a run's FHIR Bundle without a
 * server round-trip — the data is already in the client.
 */

/**
 * downloadJson serialises `data` to pretty-printed JSON and triggers a
 * client-side download with the given filename. The object URL is revoked
 * after the click to avoid leaking it.
 */
export function downloadJson(data: unknown, filename: string): void {
  const json = JSON.stringify(data, null, 2)
  const blob = new Blob([json], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
